import SearchField from 'components/styled/SearchField/SearchField';
import React, { FC, useEffect, useState } from 'react';
import escapeRegExp from 'helpers/escapeRegExp';
import GlossaryContent from './GlossaryContent';
import BrowseResults from './BrowseResults';
import {
  GlossaryData,
  ResultData,
  TopicResults,
  ContentResult,
} from './BrowseGlossary.types';
import markdownToTxt from 'markdown-to-txt';

const LINE_WIDTH = 40;

const findWords = (data: GlossaryData[], searchValue: string): ResultData[] => {
  const searchInput = escapeRegExp(searchValue).toLowerCase();

  const resultData: ResultData[] = [];
  data?.forEach((item) => {
    const topicResults: TopicResults[] = [];
    item.topics.forEach((topic) => {
      const contentResults: ContentResult[] = [];
      const searchInputLength = searchInput.length;

      const removedMD = markdownToTxt(topic.content);
      const lowerCaseContent = removedMD.toLowerCase();
      let contentPosition = lowerCaseContent.indexOf(searchInput);
      let counter = 0;
      while (contentPosition !== -1) {
        let previewContent = lowerCaseContent.substring(
          contentPosition + searchInputLength,
          contentPosition + LINE_WIDTH
        );

        const breakLinePosition = previewContent.indexOf('\\n');
        if (breakLinePosition !== -1) {
          previewContent = lowerCaseContent.substring(
            contentPosition + searchInputLength,
            contentPosition + searchInputLength + breakLinePosition
          );
        }

        contentResults.push({
          id: counter,
          content: previewContent,
        });
        contentPosition = lowerCaseContent.indexOf(
          searchInput,
          contentPosition + LINE_WIDTH
        );
        counter += 1;
      }
      if (contentResults.length > 0) {
        topicResults.push({
          name: topic.name,
          slug: topic.slug,
          results: contentResults,
        });
      } else {
        const lowerCaseTopicName = topic.name.toLowerCase();
        const topicNamePosition = lowerCaseTopicName.indexOf(searchInput);
        if (topicNamePosition > 0) {
          topicResults.push({
            name: topic.name,
            slug: topic.slug,
          });
        }
      }
    });
    if (topicResults.length > 0) {
      resultData.push({
        name: item.name,
        slug: item.slug,
        topics: topicResults,
      });
    }
  });
  return resultData;
};

interface IBrowseGlossary {
  data: GlossaryData[];
  modal: boolean;
}

const BrowseGlossary: FC<IBrowseGlossary> = ({ data, modal }) => {
  const [searchValue, setSearchValue] = useState('');
  const [result, setResult] = useState<ResultData[]>([]);

  const handleSearch = ({ target }: { target: HTMLInputElement }): void =>
    setSearchValue(target.value);

  useEffect(() => {
    if (searchValue) {
      const searchResult = findWords(data, searchValue);
      setResult(searchResult);
    } else {
      setResult([]);
    }
  }, [searchValue]);

  return (
    <>
      <SearchField
        handleSearch={handleSearch}
        value={searchValue}
        placeholder="Search"
      />
      {searchValue === '' || searchValue === undefined ? (
        <GlossaryContent data={data} modal={modal} />
      ) : (
        <BrowseResults data={result} modal={modal} searchedWord={searchValue} />
      )}
    </>
  );
};

export default BrowseGlossary;
